import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faList} from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from '@ashvin27/react-datatable';
import PropTypes from "prop-types";
import { withTranslation, WithTranslation } from "react-i18next";
import {connect} from "react-redux";
import axios from "axios";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import TemplateAddModal from "../partials/TemplateAddModal";
import TemplateUpdateModal from "../partials/TemplateUpdateModal";
import { toast, ToastContainer} from "react-toastify";
import $ from 'jquery';
import keys from "../../actions/config";
const url = keys.baseUrl;
class Emailtemplates extends Component {

    constructor(props) {
        super(props);
        const {t} = this.props;

        this.columns = [
            {
                key: "subject",
                text: t("SUBJECT"),
                className: "subject",
                align: "left",
                sortable: true,
            },
            {
                key: "identifier",
                text: t("INDENTIFIER"),
                className: "identifier",
                align: "left",
                sortable: true
            },
            {
                key: "action",
                text: t("ACTION"),
                className: "action",
                width: 100,
                align: "left",
                sortable: false,
                cell: record => {
                    return (
                        <Fragment>
                            <div className="d-flex"><button
                                data-toggle="modal"
                                data-target="#update-template-modal"
                                className="btn btn-primary btn-sm mr-2"
                                onClick={() => this.editRecord(record)}
                               >
                                <i className="fa fa-edit"></i>
                            </button>
                            <button
                                className="btn btn-outline btn-sm"
                                onClick={() => this.deleteRecord(record)}>
                                <i className="fa fa-trash"></i>
                            </button></div>
                        </Fragment>
                    );
                }
            }
        ];

        this.config = {
            page_size: 10,
            length_menu: [ 10, 20, 50 ],
            filename: "Emailtemplates",
            no_data_text: t('NO_EMAIL_TEMPLATES_FOUND'),
            language: {
                length_menu: t("SHOW_MENU"),
                filter: t("FILTER IN RECORDS"),
                info: t("SHOWING_START_END"),
                pagination: {
                    first: t("FIRST"),
                    previous: t("PREVIOUS"),
                    next: t("NEXT"),
                    last: t("LAST")
                }
            },
            show_length_menu: true,
            show_filter: true,
            show_pagination: true,
            show_info: true,
        };

        this.state = {
            records: []
        };

        this.state = {
            currentRecord: {
                id: '',
                subject: '',
                identifier: '',
                content: '',
            }
        };

        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        this.getData()
    };

    componentWillReceiveProps(nextProps) {
        this.getData()
    }

    getData() {
        axios
            .post(url+"api/template-data")
            .then(res => {
                this.setState({ records: res.data})
            })
            .catch()
    }

    editRecord(record) {
         $("#update-template-modal").find(".text-danger").hide();
        this.setState({ currentRecord: record});
    }
    addRecord() {
        $("#add-template-modal").find(".text-danger").hide();
    }
    deleteRecord(record) {
        const {t} = this.props;
      console.log(record);
        axios
            .post(url+"api/template-delete", {_id: record._id})
            .then(res => {
                if (res.status === 200) {
                   
                   toast(t("TEMPLATE_DELETED"), {
                       position: toast.POSITION.TOP_CENTER,
                   })
                }
            })
            .catch();
        this.getData();
    }

    pageChange(pageData) {
        console.log("OnPageChange", pageData);
    }

    render() {
        const {t} = this.props;
        return (
            <div>
                <Navbar/>
                {console.log('edit',this.config)}
                <div className="d-flex" id="wrapper">
                    <Sidebar/>
                    <TemplateAddModal/>
                    {console.log('currentRecords',this.state)}
                    <TemplateUpdateModal record={this.state.currentRecord} onHide={()=>{this.setState({currentRecord:{}})}}/>
                    <div id="page-content-wrapper">
                        <div className="container-fluid">
                            {/*<button onClick={() => this.addRecord()} className="btn btn-outline float-right mt-0 mr-2 btn_pos_right" data-toggle="modal" data-target="#add-template-modal"><FontAwesomeIcon icon={faPlus}/> Add Template</button>*/}
                            <h3 className="mt-2 text-secondary">{t("EMAIL_TEMPLATES_LIST")}</h3>
                            <div className="resonsive_table">
                            <ReactDatatable
                                config={this.config}
                                records={this.state.records}
                                columns={this.columns}
                                onPageChange={this.pageChange.bind(this)}
                                className="table table-bordered table-striped email_table"
                            />
                            </div>
                        </div>
                    </div>
                    <ToastContainer/>
                </div>
            </div>
        );
    }

}

Emailtemplates.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
    records: state.records
});

export default connect(
    mapStateToProps
)(withTranslation()(Emailtemplates),(Emailtemplates));
